import { RootState } from "store";
import { ActionTree } from "vuex";
import { TimeSheetApproveService } from "../service";
import timesheetService from "@/services/timesheet.service";
import { TimesheetApproveState, SET_TIME_SHEETS_APPROVE, FilterTimeSheet, SET_TOTAL_HOUR_TIME_SHEET, SET_SORT_PARAMS_TIME_SHEET } from "./types";
import { timeSheetStatusName } from '../../../dashboard/store/types'
import _ from 'lodash'
import dayjs from "dayjs";
import { convertTaskIdToType, formatTime } from "../../../../utils";
import { ProfileService } from '../../../profile/service'

const service = new TimeSheetApproveService();
const profileService =new ProfileService()
export const actions: ActionTree<TimesheetApproveState, RootState> = {

    async actLoadTimeSheetWithParams({ commit }, params: any) {
        const filterTimeSheet:FilterTimeSheet = this.getters['timeSheetsApprove/filters']
        const currentUser = this.getters['auth/currentUser']
        
        // Prepare API params
        const apiParams: any = {
            _Skip: (params.currentPage - 1) * params.pageSize,
            _Top: params.pageSize
        };
        
        // Map orderby parameter
        if (params.orderby) {
            const [field, order] = params.orderby.split(' ');
            apiParams._OrderBy = field;
            apiParams._OrderType = order || 'asc';
        }
        
        // Map filters
        if (filterTimeSheet) {
            if (filterTimeSheet.fromDay && filterTimeSheet.toDay) {
                apiParams.FromDate = filterTimeSheet.fromDay;
                apiParams.ToDate = filterTimeSheet.toDay;
            }
            
            if ((filterTimeSheet.status || filterTimeSheet.status === 0) && filterTimeSheet.status != -1) {
                apiParams.Status = filterTimeSheet.status;
            }
            
            if (filterTimeSheet.approveBy) {
                apiParams.ApproverId = filterTimeSheet.approveBy;
            }
            
            if (filterTimeSheet.search) {
                const isNumber = !isNaN(parseInt(filterTimeSheet.search));
                if (isNumber) {
                    apiParams.TimesheetHeaderId = filterTimeSheet.search;
                } else {
                    apiParams.Email = filterTimeSheet.search.toLowerCase();
                }
            }
            
            if (filterTimeSheet.searchById) {
                apiParams.TimesheetHeaderId = filterTimeSheet.searchById;
            }
            
            if (filterTimeSheet.searchSubmitter) {
                apiParams.Email = filterTimeSheet.searchSubmitter.toLowerCase();
            }
            
            if (filterTimeSheet.searchReviewer) {
                // Search reviewer in new API would need to be handled differently
                apiParams.ReviewerName = filterTimeSheet.searchReviewer.toLowerCase();
            }
            
            if (filterTimeSheet.searchApprovalGroup) {
                const isNumber = !isNaN(parseInt(filterTimeSheet.searchApprovalGroup));
                if (isNumber) {
                    apiParams.ApprovalGroupId = filterTimeSheet.searchApprovalGroup;
                } else {
                    apiParams.Search = filterTimeSheet.searchApprovalGroup.toLowerCase();
                }
            }
            
            if (filterTimeSheet.ownTimesheet) {
                apiParams.UserId = currentUser.userId;
            }
        }
        
        try {
            const result = await service.fetchTimeSheetsWithParams(apiParams);
            
            const data = result.value.map((item: TimeSheetHeader) => {
                const timeSheet: TimeSheetHeader = {
                    ...item
                }
                if (timeSheet.StartDate) {
                    timeSheet.StartDate = dayjs(timeSheet.StartDate).format('MMM DD, YYYY')
                }
                timeSheet.TimesheetLines = []
                if (timeSheet.TimesheetStatus || timeSheet.TimesheetStatus === 0) {
                    timeSheet.TimesheetStatusName = timeSheetStatusName[timeSheet.TimesheetStatus as keyof typeof timeSheetStatusName]
                }
                if (item.User) {
                    item.User.FullName = `${item.User.LastName ?? ''} ${item.User.FirstName ?? ''}`
                }
                if (item.Approver) {
                    item.Approver.FullName = `${item.Approver.LastName ?? ''} ${item.Approver.FirstName ?? ''}`
                }
                
                if (item.TimesheetLines && item.TimesheetLines.length > 0){
                    item.TimesheetLines.forEach((line)=> {
                        
                        const timesheetLine: TimeSheetLine = {
                            ...line
                        }
                        timesheetLine.JobTitle = '---'

                        if (line.TimesheetLineType === 0){
                            timesheetLine.JobType = 'Rental'
                        } else if(line.TimesheetLineType === 1){
                            timesheetLine.JobType = 'Unbill'
                        } else if(line.TimesheetLineType === 2){
                            timesheetLine.JobType = 'Job cost'
                        }

                        if (line.WorkOrderTaskId && line.WorkOrderTask) {
                            timesheetLine.JobTitle = `${line.WorkOrderTask.Name} ${line.WorkOrderTask.Description}`
                        }
                        if (line.JobCostCodeId && line.JobCostCode) {
                            timesheetLine.JobTitle = `${line.JobCostCode.Name} ${line.JobCostCode.Description}`
                        }
                        if (line.Glaccount && line.GlaccountId) {
                            timesheetLine.JobTitle = `${line.Glaccount.Description}`
                        }
                        if (line.TimesheetLineMinutes && line.TimesheetLineMinutes > 0) {
                            timesheetLine.TimesheetLineMinutesTitle = `${Math.floor(line.TimesheetLineMinutes/60)}h ${line.TimesheetLineMinutes%60}min`
                        }
                        timeSheet.TimesheetLines?.push(timesheetLine)
                    })
                }
                const totalDuration = timeSheet.TotalDuration ?? 0;
                if (totalDuration > 0){
                    timeSheet.TotalWorkingTitle = `${Math.floor(totalDuration/60)}h ${totalDuration%60}min`;
                    timeSheet.TotalWorkingHours = totalDuration/60;
                } else {
                    timeSheet.TotalWorkingTitle = '0h';
                    timeSheet.TotalWorkingHours = 0;
                }
                return timeSheet;
            });
            
            commit(SET_TIME_SHEETS_APPROVE, { lstTimeSheets: data, count: result.count });
            commit(SET_SORT_PARAMS_TIME_SHEET, params?.orderby || "");
        } catch (error) {
            // console.error("Error fetching timesheets:", error);
            commit(SET_TIME_SHEETS_APPROVE, { lstTimeSheets: [], count: 0 });
        }
    },

    async actApproveTimeSheets({ commit }, params: any){
        const result = await timesheetService.approveTimesheetV2({ ids: params.ids })
        return result
    },
    
    async actCancelTimeSheet({ commit }, params: any){
        const dataApprove = {
            Id: params.id,
            TimesheetStatus: 5
        }
        const result = await service.updateTimeSheet(dataApprove)
        return result
    },

    async actReassignApprovalGroup({ commit }, params: any) {
      const result = await service.updateApprovalGroup(params.TimesheetHeaderId, params.ApprovalGroupId)
      return result
    },

    async actFetchUserApprove({commit}, params:any){
        let filter = 'UserType ne 0'
        const result = await service.fetchUserApprove(filter)
        return result.value;
    },
};
